// extracted by mini-css-extract-plugin
module.exports = {"logos":"Logos_logos__3S68N","dark":"Logos_dark__7CVh-"};